import type { DefaultRequirement } from '@/features/CompanyQuestions/RequirementMapping/DefaultRequirement/DefaultRequirement';
import { SanitaerleitungenJahr } from '@/features/CompanyQuestions/RequirementMapping/SanitaerleitungenJahr/SanitaerleitungenJahr';
import { Elementar } from '@/features/CompanyQuestions/RequirementMapping/Elementar/Elementar';
import { Anzahlobjekte } from '@/features/CompanyQuestions/RequirementMapping/Anzahlobjekte/Anzahlobjekte';
import { DachJahr } from '@/features/CompanyQuestions/RequirementMapping/DachJahr/DachJahr';
import { ElektroleitungenJahr } from '@/features/CompanyQuestions/RequirementMapping/ElektroleitungenJahr/ElektroleitungenJahr';
import { ElementargefahrenBetroffen } from '@/features/CompanyQuestions/RequirementMapping/ElementargefahrenBetroffen/ElementargefahrenBetroffen';
import { Feuerrohbaurisiko } from '@/features/CompanyQuestions/RequirementMapping/Feuerrohbaurisiko/Feuerrohbaurisiko';
import { HeizungsrohreJahr } from '@/features/CompanyQuestions/RequirementMapping/HeizungsrohreJahr/HeizungsrohreJahr';
import { VorversicherungGekuendigt } from '@/features/CompanyQuestions/RequirementMapping/VorversicherungGekuendigt/VorversicherungGekuendigt';
import { Wohnungverm } from '@/features/CompanyQuestions/RequirementMapping/Wohnungverm/Wohnungverm';
import { VorschadenZukunft } from '@/features/CompanyQuestions/RequirementMapping/VorschadenZukunft/VorschadenZukunft';
import { HundeAnzahl } from '@/features/CompanyQuestions/HundeAnzahl/HundeAnzahl';

// handles Mappers for specific plausi fields (key = field name in API)
export const requirementClassMapper: Record<string, typeof DefaultRequirement> =
  {
    anzahl: HundeAnzahl,
    anzahlobjekte: Anzahlobjekte,
    dach_jahr: DachJahr,
    elektroleitungen_jahr: ElektroleitungenJahr,
    elementar: Elementar,
    elementargefahren_betroffen: ElementargefahrenBetroffen,
    feuerrohbaurisiko: Feuerrohbaurisiko,
    heizungsrohre_jahr: HeizungsrohreJahr,
    sanitaerleitungen_jahr: SanitaerleitungenJahr,
    vorversicherung_gekuendigt: VorversicherungGekuendigt,
    vorversicherungKuendigender: VorversicherungGekuendigt,
    wohnungverm: Wohnungverm,
    VorschadenZukunft,
  };
